export default __webpack_public_path__ + "static/media/appName.1a62a1e5.png";